<div class="filter-container">
  <div class="row">
    <div class="filter-window col-12">
      <div class="row">
        <div class="title-header col-12">
          <i class="fa fa-filter" aria-hidden="true"></i> <span class="title">{{ 'STOCK_COUNT.FILTER.FILTER' | translate }}</span>
          <span class="subtitle">{{ 'STOCK_COUNT.FILTER.TITLE' | translate }}</span>
        </div>
      </div>

      <div class="row">
        <div class="form-container col-12 row">
          <form [formGroup]="filterForm" class="row col-12">
            <div class="col-12 col-md-6">
              <div class="cell row col-12 form-group">
                <eps-select
                  [options]="shipTos"
                  label="STOCK_COUNT.FILTER.SHIPTOS"
                  formControlName="shipTos"
                  multiple
                  autoSelect
                  [showErrors]="false"
                  ></eps-select>
              </div>
              <div class="cell col-12 form-group row">
                <eps-text-input
                  label="STOCK_COUNT.FILTER.REGISTRATION_NUMBER"
                  formControlName="registrationNumber"
                  [showErrors]="false"
                  ></eps-text-input>
              </div>
            </div>

            <div class="col-12 col-md-6">
              <ng-container *ngIf="(showDatesIn2rows$ | async); else showCountDatesIn1row">
                <div class="cell col-12 form-group row">
                  <eps-date-input
                    formControlName="countDateFrom"
                    label="STOCK_COUNT.FILTER.DATE_FROM"
                    [showErrors]="false"
                  ></eps-date-input>
                </div>
                <div class="cell col-12 form-group row">
                  <eps-date-input
                    formControlName="countDateTo"
                    label="STOCK_COUNT.FILTER.DATE_TO"
                    [showErrors]="false"
                  ></eps-date-input>
                </div>
              </ng-container>
              <ng-template #showCountDatesIn1row>
                <div class="cell col-12 form-group row">
                  <eps-label-body label="STOCK_COUNT.FILTER.DATE">
                    <div class="eps-body">
                      <eps-date-input
                        formControlName="countDateFrom"
                        labelPosition="none"
                        [showErrors]="false"
                      ></eps-date-input>
                      <eps-date-input
                        formControlName="countDateTo"
                        labelPosition="none"
                        [showErrors]="false"
                      ></eps-date-input>
                    </div>
                  </eps-label-body>
                </div>
              </ng-template>
            </div>
          </form>

          <div class="row col-12 filter-buttons">
            <eps-button
              (buttonClick)="filterClicked()"
              [disabled]="filterForm.invalid || filterForm.disabled"
              [busy]="isLoading"
              buttonIcon="filter"
              label="STOCK_COUNT.BUTTONS.FILTER_TEXT"
              submit
              ></eps-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
